(function () {
  'use strict';

  var SELECTOR = '.featured-collections-premium';

  function init(el) {
    if (el._fcRevealed) return;
    el._fcRevealed = true;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.classList.add('is-revealed');
      return;
    }

    var header = el.querySelector('[data-reveal]');
    if (header) {
      var hObs = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-revealed');
            hObs.unobserve(entries[i].target);
          }
        }
      }, { threshold: 0.2 });
      hObs.observe(header);
    }

    var obs = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          el.classList.add('is-revealed');
          obs.unobserve(el);
        }
      }
    }, { threshold: 0.15 });
    obs.observe(el);
  }

  function scan() {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector(SELECTOR);
      if (el) init(el);
    });
  }
})();
